import { useEffect, useState } from "react";
import { axiosPrivate } from "../../api/axios";

/**
 * Loads an auth-protected attachment as a blob URL (revoked on unmount / change).
 * `mime` overrides the blob type so videos and PDFs can be previewed.
 */
export default function useAttachmentBlob(url, mime = null) {
  const [state, setState] = useState({ src: null, failed: false });

  useEffect(() => {
    if (!url) return undefined;
    let objectUrl;
    let cancelled = false;
    setState({ src: null, failed: false });
    axiosPrivate
      .get(url, { responseType: "blob" })
      .then(({ data }) => {
        const blob = mime ? new Blob([data], { type: mime }) : data;
        objectUrl = URL.createObjectURL(blob);
        if (cancelled) URL.revokeObjectURL(objectUrl);
        else setState({ src: objectUrl, failed: false });
      })
      .catch(() => !cancelled && setState({ src: null, failed: true }));
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [url, mime]);

  return state;
}
